import { Row, BodyText, Button, HeadingText, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { React, Fragment, memo, useEffect, useState } from 'react'
import { string } from 'prop-types'

import { fptiCustomSetup, fptiCustomClick } from '../../../utils'
import {
  PRIVACY_HOME_FROM_DELETION,
  PRIVACY_MERCHANT_HOME_FROM_DELETION,
} from '../../../constants/constants'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import serverData from '../../../utils/server-data'
import asASlide from '../../common/as-a-slide'

const { accountType = '' } = serverData

const getReturnUrl = () => {
  let { closeUrl = PRIVACY_HOME_FROM_DELETION } = serverData
  if (accountType === 'BUSINESS') {
    closeUrl = PRIVACY_MERCHANT_HOME_FROM_DELETION
  }
  return closeUrl
}

const DeletionSuccess = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION
  const [emailid, setEmailid] = useState(props.emailid)
  const [impressionDone, setImpressionDone] = useState(false)

  const { modalParams: { storedEmailid = '' } = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(deletionFpti.SUCCESS_IMPRESSION)
    }
    const email = serverData.deletionEmail || storedEmailid || ''

    setEmailid(email)
  }, [])
  return (
    <Fragment>
      <Row className="dataPrivacy-row">
        <Col>
          <HeadingText
            id="dataDeletionSuccessHeader"
            size="lg"
            className="text-center"
          >
            <Message id="dataErasure.section.finalHeading" />
          </HeadingText>
        </Col>
      </Row>

      <Row className="dataPrivacy-row">
        <Col>
          <BodyText className="text-center">
            <Message id="dataErasure.section.finalDesc" emailId={emailid} />
          </BodyText>
        </Col>
      </Row>
      <Row className="dataPrivacy-btn-row justifycenter">
        <Col
          xs={{
            span: 8,
          }}
          md={{
            span: 6,
          }}
        >
          <Button
            theme="v2"
            name="closeBtn"
            id="delete_done_btn"
            className="dataPrivacy-btn-fullwidth"
            onClick={(err) => {
              err.preventDefault()
              fptiCustomClick(deletionFpti.SUCCESS_DONE)
              location.href = getReturnUrl()
            }}
          >
            <Message id="dataErasure.section.finalButton" />
          </Button>
        </Col>
      </Row>
    </Fragment>
  )
})

DeletionSuccess.propTypes = {
  emailid: string,
}
DeletionSuccess.defaultProps = {
  emailid: '',
}

DeletionSuccess.displayName = 'DeletionSuccess'
export default asASlide({ position: 4 })(DeletionSuccess)
